import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// *  Custom Sass File
import "./scss/custom.scss";
// TODO import your Font here eg. font awesome

// * Firebase Products
import firebaseConfig from "./config/firebaseConfig";

// * Load Firebase Analytics after the page has rendered so it doesn't delay first paint
window.addEventListener("load", async () => {
  // Firebase App (the core Firebase SDK) is always required and must be listed first
  const { default: firebase } = await import("firebase/app");
  // If you enabled Analytics in your project, add the Firebase SDK for Analytics
  await import("firebase/analytics");

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
